import { render, staticRenderFns } from "./MessageNotifyDetail.vue?vue&type=template&id=78a2b2a4&scoped=true&"
import script from "./MessageNotifyDetail.vue?vue&type=script&lang=js&"
export * from "./MessageNotifyDetail.vue?vue&type=script&lang=js&"
import style0 from "./MessageNotifyDetail.vue?vue&type=style&index=0&id=78a2b2a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a2b2a4",
  null
  
)

export default component.exports